define('apps/course-intro/views/items/level',[
    'apps/course-intro/templates/items/level',
    'components/asset-player/main'
], function (template, assetPlayer) {
    "use strict";

    return Mn.ItemView.extend({

        "className": "level",

        "template": template,

        "modelEvents": {
            "change": "onChangeModel"
        },

        "initialize": function (options) {
            this.model.set({
                "levelNum": options.levelNum + 1
            });
        },

        "onChangeModel": function () {
            var playerChannel = assetPlayer.channel;

            this.render();

            playerChannel.command(playerChannel.Event.RENDER, {
                "target": this.$el
            });
        },

        "onShow": function() {
            this.$el.addClass("level-" + this.model.get("levelNum"));
        }
    });
});

